import { parseAppPath } from '@/routes';

const STORAGE_KEY = 'beatly.omni.lastCampaignPath';

/** Persist campaign detail URL (tab + optional beat, full-screen report) for “Last campaign” nav. */
export function shouldPersistCampaignPath(pathname: string): boolean {
  const p = parseAppPath(pathname);
  if (p.currentPage === 'see-campaigns' && p.campaignId) return true;
  if (p.currentPage === 'campaign-report-embed' && p.campaignId) return true;
  return false;
}

export function persistLastCampaignPathIfNeeded(pathname: string): void {
  if (!shouldPersistCampaignPath(pathname)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, pathname);
  } catch {
    // Quota or private mode — ignore
  }
}

/** Returns stored path if still valid, otherwise clears storage and returns null. */
export function readLastCampaignPath(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw || !raw.startsWith('/campaigns/')) return null;
    if (!shouldPersistCampaignPath(raw)) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return raw;
  } catch {
    return null;
  }
}
